import React from 'react';
import { BaseCardTile } from 'styled';
import { Props } from '../BaseCardTile';

const ArticleCardTile = (props: Props) => {
  return <BaseCardTile {...props} isArticle={true} />;
};

export default ArticleCardTile;
